<template>
  <a-modal
    title="修改头像"
    :visible="visible"
    :maskClosable="false"
    :confirm-loading="submitLoading"
    :width="600"
    :footer="null"
    @cancel="cancelHandel"
  >
    <a-row>
      <a-col :xs="24" :md="12" class="no-cropper-tip">
        <p>裁剪功能暂未开放，当前仅支持直接上传头像。</p>
        <p>请选择一张 2MB 以内的图片，点击“保存”即可更新头像。</p>
      </a-col>
      <a-col :xs="24" :md="12" :style="{ height: '220px' }">
        <div class="avatar-upload-preview">
          <a-avatar :size="180" :src="previewUrl || avatar" />
        </div>
      </a-col>
    </a-row>
    <br />
    <a-row type="flex" justify="start" align="middle">
      <a-col :lg="4" :md="6">
        <a-upload
          name="file"
          :beforeUpload="beforeUpload"
          :showUploadList="false"
        >
          <a-button icon="upload">选择图片</a-button>
        </a-upload>
      </a-col>
      <a-col :lg="{ span: 4, offset: 12 }" :md="6">
        <a-button type="primary" :loading="uploading" @click="finish" class="save-button"
          >保存</a-button
        >
      </a-col>
    </a-row>
  </a-modal>
</template>

<script>
import { $on, $off, $once, $emit } from '../../../utils/gogocodeTransfer'
import store from '@/store'
import { uploadAvatar } from '@/api/system/user'
import { mapGetters } from 'vuex'
import UploadFileToOSS from '@/utils/upload-file-to-oss'

export default {
  data() {
    return {
      visible: false,
      id: null,
      submitLoading: false,
      fileList: [],
      uploading: false,
      uploadedUrl: '',
      previewUrl: '',
    }
  },
  computed: {
    ...mapGetters(['avatar']),
  },
  methods: {
    edit(id) {
      this.visible = true
      this.id = id
      this.uploadedUrl = ''
      this.previewUrl = this.avatar
    },

    close() {
      this.id = null
      this.visible = false
      this.uploadedUrl = ''
      this.previewUrl = ''
    },
    cancelHandel() {
      this.close()
    },
    beforeUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 2
      if (!isLt2M) {
        this.$message.error('图片大小需小于2MB')
        return false
      }
      this.uploadToOss(file)
      return false
    },

    // 上传图片（点击上传按钮）
    finish() {
      if (!this.uploadedUrl) {
        this.$message.warning('请先上传图片后再保存')
        return
      }
      uploadAvatar({ avatarUrl: this.uploadedUrl }).then((response) => {
        const newUrl = response.data?.imgUrl || this.uploadedUrl
        store.commit('SET_AVATAR', newUrl)
        this.$message.success('保存成功')
        $emit(this, 'ok', newUrl)
        this.visible = false
        this.uploadedUrl = ''
      })
    },
    okHandel() {
      const vm = this

      vm.submitLoading = true
      setTimeout(() => {
        vm.submitLoading = false
        vm.close()
        vm.$message.success('上传头像成功')
      }, 2000)
    },
    uploadToOss(file) {
      this.uploading = true
      new UploadFileToOSS([file], {
        finally: (res) => {
          this.uploading = false
          if (Array.isArray(res) && res.length) {
            const item = res[0]
            this.uploadedUrl = item.path || item.url
            this.previewUrl = item.url || item.path || ''
            this.$message.success('上传成功，点击保存生效')
          } else {
            this.$message.error('上传失败，请重试')
          }
        },
      })
    },
  },
  emits: ['ok'],
}
</script>

<style lang="less" scoped>
/* 保存按钮样式 */
.save-button {
  background-color: #165DFF !important;
  border-color: #165DFF !important;
  border-radius: 4px !important;
  color: #FFFFFF !important;
}

.save-button:hover:not(:disabled) {
  background-color: #4080ff !important;
  border-color: #4080ff !important;
  color: #FFFFFF !important;
}

.save-button:focus:not(:disabled) {
  background-color: #165DFF !important;
  border-color: #165DFF !important;
  color: #FFFFFF !important;
}

.avatar-upload-preview {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}
.no-cropper-tip {
  padding: 10px 16px;
  line-height: 1.8;
}
</style>
